import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=9fa017a8&"
import script from "./Tab1.vue?vue&type=script&lang=js&"
export * from "./Tab1.vue?vue&type=script&lang=js&"
import style0 from "./Tab1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports